import script from "./PreviewImkpPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewImkpPage.vue?vue&type=script&setup=true&lang=js"

import "./PreviewImkpPage.vue?vue&type=style&index=0&id=7a857efc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a857efc"]])

export default __exports__